import api from './axios';

export interface Gallery {
    id: string;
    title: string;
    imageUrl: string;
    description?: string;
    category: string;
    createdAt?: string;
}

export interface CreateGalleryData {
    title: string;
    imageUrl: string;
    category: string;
    description?: string;
}

export const settingsApi = {
    getAllGalleries: async (): Promise<Gallery[]> => {
        const response = await api.get('/settings/all-images');
        return response.data;
    },

    createGallery: async (data: CreateGalleryData): Promise<Gallery> => {
        const response = await api.post('/settings/add-image', data);
        return response.data;
    },

    updateGallery: async (id: string, data: CreateGalleryData): Promise<Gallery> => {
        const response = await api.patch(`/settings/update-image/${id}`, data);
        return response.data;
    },

    deleteGallery: async (id: string): Promise<void> => {
        await api.delete(`/settings/remove-image/${id}`);
    },

    uploadGalleryImage: async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('file', file);

        const response = await api.post('/settings/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data.url;
    }
};
